<div class="spinner-container" *ngIf="this.loadingService.loading$ | async">
  <!-- <mat-spinner></mat-spinner> -->
  <i class="fa fa-refresh fa-spin spinner-white" aria-hidden="true"></i>
</div>